<mat-dialog-content>
  <div class="flex flex-col items-center gap-6 py-4 px-2 text-center">
    <mat-spinner diameter="48"></mat-spinner>
    <div class="flex flex-col gap-2">
      <h2 class="text-xl font-semibold text-gray-900" i18n>Preparing your data</h2>
      <p class="text-gray-500 text-sm leading-relaxed" i18n>
        The server is currently processing your documentation.<br>
        This will only take a moment.
      </p>
    </div>
  </div>
</mat-dialog-content>
